import * as Yup from 'yup';

export const productName = Yup.string()
  .trim()
  .max(100, 'Product name should be less than 20 symbols')
  .required('Product name is required');
